import { createBrowserClient } from "@supabase/ssr"

let client: ReturnType<typeof createBrowserClient> | null = null

export function getSupabaseClient() {
  if (!client) {
    const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
    const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

    if (!supabaseUrl) {
      throw new Error("Missing NEXT_PUBLIC_SUPABASE_URL environment variable. Please check your Project Settings.")
    }

    if (!supabaseAnonKey) {
      throw new Error("Missing NEXT_PUBLIC_SUPABASE_ANON_KEY environment variable. Please check your Project Settings.")
    }

    client = createBrowserClient(supabaseUrl, supabaseAnonKey)
  }
  return client
}

export function createClient() {
  return getSupabaseClient()
}

export const supabase = new Proxy({} as ReturnType<typeof createBrowserClient>, {
  get(target, prop) {
    return getSupabaseClient()[prop as keyof ReturnType<typeof createBrowserClient>]
  },
})

export type Database = {
  public: {
    Tables: {
      tasks: {
        Row: {
          id: string
          title: string
          description: string | null
          status: "todo" | "in-progress" | "done"
          priority: "low" | "medium" | "high" | "urgent"
          project_id: string | null
          owner_id: string
          created_at: string
          updated_at: string
          today: boolean | null
        }
        Insert: {
          id?: string
          title: string
          description?: string | null
          status?: "todo" | "in-progress" | "done"
          priority?: "low" | "medium" | "high" | "urgent"
          project_id?: string | null
          owner_id: string
          created_at?: string
          updated_at?: string
          today?: boolean | null
        }
        Update: {
          id?: string
          title?: string
          description?: string | null
          status?: "todo" | "in-progress" | "done"
          priority?: "low" | "medium" | "high" | "urgent"
          project_id?: string | null
          owner_id?: string
          created_at?: string
          updated_at?: string
          today?: boolean | null
        }
      }
      projects: {
        Row: {
          id: string
          name: string
          description: string | null
          owner_id: string
          created_at: string
          updated_at: string
        }
      }
    }
  }
}
